<template>
  <div class="more-info">
    <button class="mk-btn mk-btn--default" @click="onClick">
      {{ btnContent }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'LoadMoreBtn',
  components: {},
  directives: {},
  props: {
    onClick: {
      type: Function,
      default: () => {}
    },
    btnContent: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
  },
  updated() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/component/button.scss';
.more-info {
  width: 100%;
  text-align: center;
}
@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {}
</style>
